import React from 'react';
import { useQuery } from '@apollo/client';
import getOperationalAlertCounts from './getOperationalAlertCounts.graphql';

// Admin dashboard card: at-a-glance operational alerts. Each tile links to its
// full detail list. Demand with no pro (unfulfilled) + orders that stalled.
const cardStyle = {
  background: '#fff', border: '1px solid #EDE7E7', borderRadius: 12,
  padding: '18px 20px', margin: '18px 0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
};
const tile = (accent) => ({
  flex: 1, minWidth: 200, textDecoration: 'none', color: 'inherit',
  border: `1px solid ${accent}33`, borderLeft: `4px solid ${accent}`,
  borderRadius: 10, padding: '14px 16px', background: `${accent}0D`,
  display: 'block',
});

const OperationalAlerts = () => {
  const { data } = useQuery(getOperationalAlertCounts, { fetchPolicy: 'network-only', ssr: false });
  const c = (data && data.getOperationalAlertCounts) || {};
  const unfulfilled = c.unfulfilledCount || 0;
  const stalled = c.stalledCount || 0;

  return (
    <div style={cardStyle}>
      <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: '.06em', textTransform: 'uppercase', color: '#8A8A8A', marginBottom: 12 }}>
        Operational alerts
      </div>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <a href="/siteadmin/unfulfilled-bookings" style={tile('#D64550')}>
          <div style={{ fontSize: 30, fontWeight: 800, lineHeight: 1, color: '#D64550' }}>{unfulfilled}</div>
          <div style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>Unfulfilled — no pro found</div>
          <div style={{ fontSize: 12, color: '#777', marginTop: 2 }}>A client ordered but no worker accepted &rarr;</div>
        </a>
        <a href="/siteadmin/stalled-bookings" style={tile('#B45309')}>
          <div style={{ fontSize: 30, fontWeight: 800, lineHeight: 1, color: '#B45309' }}>{stalled}</div>
          <div style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>Stalled / abandoned</div>
          <div style={{ fontSize: 12, color: '#777', marginTop: 2 }}>Started, open &gt; 24h, never completed &rarr;</div>
        </a>
      </div>
    </div>
  );
};

export default OperationalAlerts;
